import { render, staticRenderFns } from "./GroupGoods.vue?vue&type=template&id=2cf275f5&scoped=true&"
import script from "./GroupGoods.vue?vue&type=script&lang=js&"
export * from "./GroupGoods.vue?vue&type=script&lang=js&"
import style0 from "./GroupGoods.vue?vue&type=style&index=0&id=2cf275f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf275f5",
  null
  
)

export default component.exports